import * as React from "react";
import { Box, Tooltip, TooltipProps, makeStyles } from "@material-ui/core";
import { themeVariables, IThemeSettings } from "../_Theme";
import * as styles from "./styles.scss";

interface IProps extends Partial<TooltipProps> {
  title: any;
  children?: any;
  bgcolor?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
  dark?: boolean;
}

const useStyles = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
    opacity: 0.8,
  },
  tooltip: {
    backgroundColor: "rgba(0, 0, 0, 0.8)",
  },
}))

export const MUITooltip = ({ bgcolor, children, dark, ...ttProps }: IProps) => {
  const darkTooltip = useStyles();

  return (
    <Tooltip
      arrow
      leaveDelay={0}
      enterTouchDelay={0}
      {...ttProps}
      classes={dark ? darkTooltip : null}
    >
      {children ? (
        children
      ) : (
        <Box
          component="span"
          bgcolor={
            bgcolor
              ? themeVariables.palette.marks[bgcolor]
              : themeVariables.palette.grey.A700
          }
          className={styles.tooltip}
        >
          ?
        </Box>
      )}
    </Tooltip>
  );
};
